"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.DeviceMarkers = exports.DeviceLocationsQuery = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const geography_1 = require("../../../../geography");
const Device = __importStar(require("../../../device"));
const Dashboard = __importStar(require("../../dashboard/overview"));
const Protocol = __importStar(require("../protocol"));
const authorization_1 = require("./authorization");
const device_filters_1 = require("./device-filters");
const Error = __importStar(require("./error"));
const Tenant = __importStar(require("./tenant"));
const tracing_1 = require("./tracing");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Dashboard';
const getOverviewPage = platform_1.HttpApiEndpoint.get('getOverviewPage') `/overview`
    .middleware(Tenant.Middleware)
    .setUrlParams(Dashboard.OverviewPageQuery)
    .addSuccess(Protocol.responseBodySuccess(Dashboard.OverviewPage))
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Fleet Overview')
    .annotate(platform_1.OpenApi.Description, 'Fetch cached fleet overview counters');
const ConnectionStateFromNumber = effect_1.Schema.transformLiterals([0, 'disconnected'], [1, 'connected']);
// Adding a 'none' value to indicate that this device has no alarms
const SeverityFromNumber = effect_1.Schema.transformLiterals([0, 'non-critical'], [1, 'critical'], [2, 'none']);
const ConsumableConditionFromNumber = effect_1.Schema.transformLiterals([0, 'critical'], [1, 'warning'], [2, 'ok']);
const DeviceMarker = (extraField) => effect_1.Schema.Tuple(geography_1.Latitude, geography_1.Longitude, extraField);
const makeMarkersFor = (tag, extraField) => effect_1.Schema.Struct({
    includes: effect_1.Schema.tag(tag),
    devices: effect_1.Schema.Record({
        key: Device.Class.Common.Id,
        value: DeviceMarker(extraField),
    }),
});
exports.DeviceLocationsQuery = effect_1.Schema.Struct({
    ...device_filters_1.CommonDeviceFilterFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceLocationsQuery`,
    description: 'Query parameters for fetching device locations',
});
exports.DeviceMarkers = effect_1.Schema.Union(makeMarkersFor('ConnectionState', ConnectionStateFromNumber), makeMarkersFor('Alarms', SeverityFromNumber), makeMarkersFor('FilterStatus', ConsumableConditionFromNumber), makeMarkersFor('Co2Status', ConsumableConditionFromNumber), makeMarkersFor('EnhancementsStatus', ConsumableConditionFromNumber)).annotations({
    identifier: `${exports.NAMESPACE}.DeviceMarkers`,
    description: 'Device markers with location and extra field data',
});
const getDeviceLocations = platform_1.HttpApiEndpoint.get('getDeviceLocations') `/device-locations`
    .middleware(Tenant.Middleware)
    .setUrlParams(exports.DeviceLocationsQuery)
    .addSuccess(Protocol.responseBodySuccess(exports.DeviceMarkers), {
    status: 200,
})
    .addError(Error.NotFoundErrorFromProtocol)
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Device Locations')
    .annotate(platform_1.OpenApi.Description, 'Get a list of devices with their location data, filtered by connection state, model, alarm types, alarm severities, and consumable level.');
exports.Spec = platform_1.HttpApiGroup.make('dashboard')
    .middleware(authorization_1.UserAuthorization)
    .middleware(tracing_1.Tracing)
    .add(getOverviewPage)
    .add(getDeviceLocations)
    .prefix('/dashboard')
    .annotate(platform_1.OpenApi.Title, 'Dashboard')
    .annotate(platform_1.OpenApi.Description, 'Dashboard endpoints');
//# sourceMappingURL=dashboard.js.map